<template>
  <div class="footSubmit">
    <div v-if="tables">
      <el-button
        style="float: right; margin-right: 30px"
        size="small"
        type="primary"
        v-preventReClick
        @click="toNext()"
        >{{ nextTitle }}</el-button
      >
    </div>
    <div v-else>
      <el-button
        style="float: right; margin-right: 30px"
        size="small"
        type="primary"
        v-preventReClick
        @click="toReject()"
        >{{ rejectTitle }}</el-button
      >
      <el-button
        style="float: right; margin-right: 30px"
        size="small"
        type="primary"
        v-preventReClick
        @click="toPass()"
        >{{ passTitle }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nextTitle: {
      type: String,
      default: '下一步'
    },
    rejectTitle: {
      type: String,
      default: '拒绝'
    },
    passTitle: {
      type: String,
      default: '通过'
    }
  },
  data() {
    return {
      activeName: '1',
      tables: true
    }
  },
  methods: {
    toNext() {
      this.$emit('activeName', this.activeName)
    }
  }
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/enterprise/enterpriseFoot.vue